require('./AmazonGiftCardReturnView.scss')

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @actions
const amazonGiftCardActions = require('actions/amazonGiftCard');
const retailLoanActions = require("ok-loans/src/actions/contractRetailLoan");

// @components
const AmazonGiftCardReturnConfirmation = require('components/amazonGiftCardReturn/amazonGiftCardReturnConfirmation');

// @constants
import { NEGATIVE } from 'constants/layout';
const {
    SELECTED_RADIO_COUPON
} = require('constants/accountAmazonGiftCard');

// @commons
import OKLayout from 'components/commons/OKLayout/OKLayout';

// @utilities
const { formatText } = require('core/i18n').i18n;

// @assets
const openMarketsIcon = require('assets/images/icon-openmarkets-filled.svg');

class AmazonGiftCardReturnView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSubmitLoading: false
        }

        this.getIbanFromContractNumber = this.getIbanFromContractNumber.bind(this);
        this.handleConfirmClick = this.handleConfirmClick.bind(this);
        this.navigateToCodigos = this.navigateToCodigos.bind(this);
    }

    componentWillUnmount() {
        const { resetErrorStatus, resetAmazonReturnCardState } = this.props;
        resetAmazonReturnCardState();
        resetErrorStatus();
    }

    getIbanFromContractNumber() {
        const { immAccounts, immAmazonGiftCard } = this.props;
        const numerodecontrato = immAmazonGiftCard.get('numerodecontrato');
        const immAccountsById = immAccounts.get('byId');
        const immAccountsByOrder = immAccounts.get('byOrder');
        const selectedAccountId = immAccountsByOrder.find(accountId => {
            const immAccount = immAccountsById.get(accountId);
            return immAccount.get('contractNumber') === numerodecontrato;
        });

        return immAccounts.getIn(['byId', selectedAccountId, 'iban']);
    }

    navigateToCodigos() {
        const { history, match: { params: { accountId } } } = this.props;
        const query = { activeTab: SELECTED_RADIO_COUPON };

        history.push({
            query,
            pathname: `/myprofile/accounts/${accountId}/amazon-gift-check`
        });
    }

    handleConfirmClick() {
        const {
            getConsentStatus,
            immAmazonGiftCard,
            returnAmazonGiftCard
        } = this.props;
        const amount = immAmazonGiftCard.get('amount');
        const requestId = immAmazonGiftCard.get('requestId');
        const codeIban = this.getIbanFromContractNumber();

        if (!__CONTACT_CENTER__) {
            this.setState({ isSubmitLoading: true });
            const successCallback = response => {
                this.setState({ isSubmitLoading: false });
                const amazonConsent = (response.find(consent => consent.consentCell.id === '02') || {}).status;
                if (amazonConsent === 'ACCEPTED') {
                    returnAmazonGiftCard(amount, requestId, codeIban);
                }
            };
            getConsentStatus(successCallback)
        } else {
            returnAmazonGiftCard(amount, requestId, codeIban);
        }
    }

    render() {
        const {
            immAccounts,
            immAmazonGiftCard,
            immRetailLoan,
            match: { params: { accountId } }
        } = this.props;
        const { isSubmitLoading } = this.state;
        const immAccount = immAccounts.getIn(['byId', accountId]);
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-accounts'),
                url: '/myprofile/accounts'
            },
            {
                text: immAccount.get('alias'),
                url: `/myprofile/accounts/${accountId}/movements`
            },
            {
                text: formatText('breadcrumb-amazonGiftCard'),
                url: `/myprofile/accounts/${accountId}/amazon-gift-check-return`
            }
        ];
        const headerIcon = (
            <img src={openMarketsIcon} className="openmarkets-icon" />
        );

        return (
            <div className="amazon-gift-card-return-view">
                <OKLayout
                    breadcrumb={mappingBreadcrumb}
                    contentPosition={NEGATIVE}
                    title={formatText('amazonGiftCard-pageTitle')}
                    section="accounts"
                    buttons={headerIcon}
                >
                    <AmazonGiftCardReturnConfirmation
                        accountId={accountId}
                        immAccounts={immAccounts}
                        immAmazonGiftCard={immAmazonGiftCard}
                        immRetailLoan={immRetailLoan}
                        isLoading={isSubmitLoading}
                        navigateToCodigos={this.navigateToCodigos}
                        handleConfirmClick={this.handleConfirmClick}
                    />
                </OKLayout>
            </div>
        )
    }
}

AmazonGiftCardReturnView.propTypes = {
    getConsentStatus: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAmazonGiftCard: PropTypes.object.isRequired,
    immRetailLoan: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    resetAmazonReturnCardState: PropTypes.func.isRequired,
    resetErrorStatus: PropTypes.func.isRequired,
    returnAmazonGiftCard: PropTypes.func.isRequired
};

module.exports.constructor = AmazonGiftCardReturnView;
module.exports.AmazonGiftCardReturnView = connect(
    state => ({
        immAccounts: state.accounts,
        immAmazonGiftCard: state.amazonGiftCards,
        immRetailLoan: state.contractRetailLoan,
    }),
    {
        getConsentStatus: retailLoanActions.getConsentStatus,
        resetAmazonReturnCardState: amazonGiftCardActions.resetAmazonReturnCardState,
        resetErrorStatus: retailLoanActions.simpleActions.retailLoanResetErrorsStatus,
        returnAmazonGiftCard: amazonGiftCardActions.returnAmazonGiftCard
    }
)(withRouter(AmazonGiftCardReturnView));
